import styles from './styles.scss';

export default function ErrorMessage({ text }) {
    return (
        <p className={styles.errorMessage}>{text} is required</p>
    );
}